import { useCIMSTableContext } from '../../../../..'
import { WithRecord } from '../../../../../../types'
import DisablableRowActionButton from './DisablableRowActionButton'

function EditRowActionButton<T extends object>({ record }: WithRecord<T>) {
  const {
    modals: { simpleEdit },
    actions,
  } = useCIMSTableContext<T>()
  const { modal, hidden, disabled } = actions.row?.edit ?? {}
  const hide = typeof hidden === 'function' ? hidden(record) : hidden
  if (hide) return null

  return (
    <DisablableRowActionButton
      record={record}
      disabled={disabled}
      callback={(record) => {
        if (modal?.type === 'custom') return modal.toggle(record)
        return simpleEdit.toggle(record)
      }}
    >
      Edit
    </DisablableRowActionButton>
  )
}

export default EditRowActionButton
